/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'underscore'
], (_) => {
	const DefaultPaletteLength = 5;
	class VCFUpgradeUtils {
		buildIndexMap(paletteLength, rangesLength) {
			if(paletteLength <= rangesLength){
				return _.range(paletteLength);
			}
			if(paletteLength === DefaultPaletteLength){
				const fiveColorPalleteMaps = [
					[4], // one color
					[0, 4], // two colors
					[0, 2, 4], // three colors
					[0, 1, 2, 4], // four colors
					[0, 1, 2, 3, 4] // five colors
				];
				const colorIndexMap = fiveColorPalleteMaps[rangesLength - 1];
				return colorIndexMap;
			}

			if(rangesLength === 1){
				return [Math.floor(paletteLength / 2)];
			}

			const step = (paletteLength - 1) / rangesLength;
			const indexMap = [0];
			for (let i = 2; i < rangesLength; i++) {
				indexMap.push(Math.floor(step * i));
			}
			indexMap.push(paletteLength - 1);

			return indexMap;
		}
	}

	return new VCFUpgradeUtils();
});
